{
  "title": "Instantánea de Hoy",
  "portfolios_one": "{{count}} cartera",
  "portfolios_other": "{{count}} carteras",
  "aumLabel": "{{value}} AUM",
  "marketStatus": {
    "preMarket": "Pre-mercado",
    "open": "Mercado abierto",
    "afterHours": "Horas post-cierre",
    "closed": "Mercado cerrado"
  },
  "clickableSnapshotCard": "Tarjeta de instantánea interactiva",
  "asOfLabel": "Al {{value}}"
}
